import { dateFns } from '@lhb/func';
/**
 * @param {Object} obj  要删除属性的目标对象
 * 删除对象的属性值为null或undefined或者''
 */
export function deleteTargetProperty(obj) {
    var result = JSON.parse(JSON.stringify(obj));
    for (var item in result) {
        if (result[item] === null || result[item] === undefined || result[item] === '') {
            Reflect.deleteProperty(result, item);
        }
    }
    return result;
}
/**
 * 函数去抖, 规定时间之后再去执行函数
 * @param {*} method 要执行的函数
 * @param {*} delay 延时时间，单位毫秒
 * @param {*} context 上下文环境
 */
export var fcDebounce = function (method, delay, context) {
    clearTimeout(method.timer);
    method.timer = setTimeout(function () {
        method.call(context);
    }, delay);
};
/**
 * 获取url参数
 * @param {*} variable query名称
 */
export var getQueryVariable = function (variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return false;
};
/**
 * 转换分页参数
 * @param page 页码
 * @param pageSize 分页条数
 */
export var formatPageParams = function (page, pageSize) {
    var offset = page > 1 ? (page - 1) * pageSize : 0;
    return {
        offset: offset,
        limit: pageSize,
    };
};
/**
 * 获取文件类型对应icon
 * @param name 文件名
 * @returns icon name
 */
export var getFileIcon = function (name) {
    var nameArr = name.split('.');
    var nameType = nameArr[nameArr.length - 1];
    switch (nameType) {
        case 'pdf':
            return 'iconfile_icon_ppt';
        case 'docx':
        case 'doc':
            return 'iconfile_icon_word';
        case 'ppt':
        case 'pptx':
            return 'iconfile_icon_ppt';
        case 'xlsx':
        case 'xls':
            return 'iconfile_icon_excel';
        default:
            return 'iconfile_icon_unknow';
    }
};
/**
 * 档期数组转字符串
 * @param dates ['2022-10-08', '2022-10-09']
 * @returns 2022.10.08-2022.10.09(共2天)
 */
export var formatDatesString = function (dates) {
    var len = dates.length;
    if (len < 1)
        return '-';
    if (len === 1) {
        return dates[0] + "(\u51711\u5929)";
    }
    var firstDate = Date.parse(dates[0]);
    for (var i = 1; i < len; i++) {
        var curDate = Date.parse(dates[i]);
        var days = (curDate - firstDate) / (24 * 60 * 60 * 1000);
        if (days !== i) {
            if (i === 1) {
                return dateFns.changeTime(dates[0], '.', true) + "\u3001" + dateFns.changeTime(dates[i], '.', true) + (i === len - 1 ? '' : '...') + "(\u5171" + dates.length + "\u5929)";
            }
            else {
                return dateFns.changeTime(dates[0], '.', true) + "-" + dateFns.changeTime(dates[i - 1], '.', true) + (i === len - 1 ? '' : '...') + "(\u5171" + dates.length + "\u5929)";
            }
        }
        if (i === len - 1) {
            return dateFns.changeTime(dates[0], '.', true) + "-" + dateFns.changeTime(dates[i], '.', true) + "(\u5171" + dates.length + "\u5929)";
        }
    }
    return '-';
};
